import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import { emailMap } from '@/components/productRiver/river2/Details/components/A/signUpFormConf';

const { EFPic } = createEFPic('/media/river2/h5/');

export default function A() {
    const { useEffect, useLang, useRouter, useState, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'cis', 'za', 'au']);
    const [enter, setEnter] = useState(false);
    const emailConf = emailMap[locale] || {};
    const [popupVisible, setPopupVisible] = useState(false);

    useEffect(() => {
        let timer: any;
        if (!enter && typeof window !== 'undefined') {
            timer = setTimeout(() => {
                setEnter(true);
            }, 500);
        }
        return () => {
            timer = null;
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className={`river2_details_A ${css.A_1}`}>
            <div className="innerBox">
                <div className="imgBox">
                    {locale === 'ph' ? (
                        <img
                            src="https://websiteoss.ecoflow.com/upload/image/1751271028396/kv-h5.jpg"
                            className="fullImgs"
                            alt={t('river2.details.sec1_title')}
                            aria-label={t('river2.details.sec1_title')}
                        />
                    ) : (
                        <EFPic
                            name={[`1_${imgSpec}.webp`, `1_${imgSpec}.jpg`]}
                            className="fullImgs"
                            alt={t('river2.details.sec1_title')}
                            aria-label={t('river2.details.sec1_title')}
                        />
                    )}
                    <div className={`textBox ${enter ? 'enter' : ''}`}>
                        {[''].includes(locale) && <p className="date">{t('river2.details.sec1_date')}</p>}
                        <p className="title">{t('river2.details.sec1_title')}</p>
                        <p className="desc">{t('river2.details.sec1_desc')}</p>
                    </div>
                    {[''].includes(locale) && (
                        <div className={`formArea ${enter ? 'enter' : ''}`}>
                            {locale === 'au' && <div className="more">{t('river2.sec1_more')}</div>}
                            {emailConf?.type === 'klaviyo' && (
                                <Klaviyo
                                    extra_properties={{
                                        custom_source: emailConf.source,
                                        $source: emailConf.source,
                                        $method_type: 'Klaviyo Form',
                                        $consent_version: 'Embed default text',
                                        $consent_form_id: emailConf.consent_form_id,
                                    }}
                                    successCallback={() => {
                                        setPopupVisible(true);
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('river2.sec1_btn_text'),
                                                status: 'success',
                                            });
                                            window?.fbq && window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                    errorCallback={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('river2.sec1_btn_text'),
                                            status: 'fail',
                                        });
                                    }}
                                >
                                    <KlaviyoView
                                        list_id={emailConf.list_id}
                                        submitText={t('river2.sec1_btn_text')}
                                        placeholder={t('river2.sec1_input_placeholder')}
                                    />
                                </Klaviyo>
                            )}
                            {emailConf.type === 'mailchimp' && (
                                <Mailchimp
                                    successCallback={() => {
                                        setPopupVisible(true);
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('river2.sec1_btn_text'),
                                                status: 'success',
                                            });
                                            window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                    errorCallback={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('river2.sec1_btn_text'),
                                            status: 'fail',
                                        });
                                    }}
                                >
                                    <MailchimpView
                                        action={emailConf.action}
                                        extraFields={emailConf?.extraFields}
                                        submitText={t('river2.sec1_btn_text')}
                                        placeholder={t('river2.sec1_input_placeholder')}
                                    />
                                </Mailchimp>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <Popup
                visible={popupVisible}
                title={t('river2.popup_title')}
                richContent={{ langKey: 'productriver2', key: 'river2.popup_content' }}
                buttonText={t('river2.popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
            <style jsx global>
                {`
                    .detail-nav {
                        .right {
                            .btn-link {
                                display: ${locale === '' ? 'none' : 'block'};
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
